import { apiClient } from '@indipia/shared';

/**
 * 외부 링크 사진 <img src> 용 URL. 공유 쿠키가 같은 출처로 자동 전송되므로
 * 쿼리에 shareId를 붙이지 않는다. 입력이 '/api/...'면 선행 '/api'를 제거해 baseURL과 중복되지 않게 한다.
 */
export function guestFileUrl(path: string): string {
  const stripped = path.startsWith('/api/') ? path.slice(4) : path;
  return `${apiClient.defaults.baseURL ?? ''}${stripped}`;
}
